import { RcV2CheckoutBannerComponent } from './components/checkout-banner/checkout-banner.component';
import { RcV2CheckoutFormComponent } from './components/checkout-form/checkout-form.component';

export let rcV2ComponentMap = {
  'rcv2-checkout-banner': RcV2CheckoutBannerComponent,
  'rcv2-checkout-form': RcV2CheckoutFormComponent,
};

export const changeRcV2ComponentMap = (newMap: {
  [key: string]: any;
}): void => {
  rcV2ComponentMap = {
    ...rcV2ComponentMap,
    ...newMap,
  };
};
